import { Feather } from "@expo/vector-icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { ViewStyle } from "react-native";
import { Button } from "./ui/Button";

interface PhoneSignInButtonProps {
  onPress: () => void;
  disabled?: boolean;
  style?: ViewStyle;
  labelKey?: string;
  square?: boolean;
}

export const PhoneSignInButton: React.FC<PhoneSignInButtonProps> = ({
  onPress,
  disabled,
  style,
  labelKey = "SIGN_UP_WITH_PHONE",
  square,
}) => {
  const { t } = useTranslation();

  if (square) {
    return (
      <Button
        onPress={onPress}
        disabled={disabled}
        accessibilityLabel={t(labelKey)}
        style={[
          {
            backgroundColor: "#fff",
            width: 56,
            height: 56,
            maxWidth: undefined,
            paddingHorizontal: 0,
            paddingVertical: 0,
            borderWidth: 1,
            borderColor: "#ccc",
          },
          style,
        ]}
        icon={<Feather name="phone" size={22} color="#000" />}
      />
    );
  }

  return (
    <Button
      onPress={onPress}
      disabled={disabled}
      text={t(labelKey)}
      style={[
        {
          backgroundColor: "#fff",
          width: "100%",
          maxWidth: 350,
          borderWidth: 1,
          borderColor: "#ccc",
        },
        style,
      ]}
      textStyle={{ color: "#000", fontWeight: "normal" }}
      icon={<Feather name="phone" size={22} color="#000" />}
    />
  );
};
